import { MutationTree } from 'vuex';
import * as TYPES from './types';
import { IState } from './state';
import { Message } from 'element-ui';
import Vue from 'vue';

export const mutations: MutationTree<any> = {

    // 获取产品体验中心数据信息
    [TYPES.GET_SYSTEMCONFIG_NAME.REQUEST](state: IState) {
        state.systemConfigList.loading = true;
    },
    [TYPES.GET_SYSTEMCONFIG_NAME.SUCCESS](state: IState, payload) {        
        let { Data } = payload.res || { Data: [] };        
        const { HomePage } = payload.req;
        state.systemConfigList.loading = false;
        Data = Array.isArray(Data) ?
            Data.map((item: any) => {
                if (typeof item.Value === 'string') {
                    const value = JSON.parse(item.Value);
                    const newValue: any[] = [];
                    if (HomePage) {
                        value.forEach((v: any) => {
                            if (v.HomePage === 'true') {
                                newValue.push(v);
                            }
                        });

                        return {...item, Value: newValue };
                    } else {
                        return {...item, Value: value };
                    }
                }

                return Data;
            }) : [];
        state.systemConfigList.infos = Data;    
        state.systemConfigList.infos = payload.res.Data;      
    },
    [TYPES.GET_SYSTEMCONFIG_NAME.FAILED](state: IState) {
        state.systemConfigList.loading = false;
    },

     // 获取在线课堂和产品文档首页数据
     [TYPES.GET_LEFT_SYSTEMCONFIG_NAME.REQUEST](state: IState) {
        state.classOnLine.loading = true;
        state.docCenter.loading = true;
    },
    [TYPES.GET_LEFT_SYSTEMCONFIG_NAME.SUCCESS](state: IState, payload) {
        state.classOnLine.loading = false;
        state.docCenter.loading = false;
        const { Data } = payload.res || { Data: [] };
        Data.forEach((item: any) => {
            item.Value = typeof item.Value === 'string' ? JSON.parse(item.Value) : item.Value;
            if (item.Text === '在线课堂') {
                state.classOnLine.infos = item;
            } else if (item.Text === '产品文档'){
                state.docCenter.infos = item;
            }
        });
    },
    [TYPES.GET_LEFT_SYSTEMCONFIG_NAME.FAILED](state: IState) {
        state.classOnLine.loading = false;
        state.docCenter.loading = false;
    },

     // 获取在线课堂和产品文档首页数据
     [TYPES.GET_FOLDER_FILES_NAME.REQUEST](state: IState) {
        state.fileList.loading = true;
    },
    [TYPES.GET_FOLDER_FILES_NAME.SUCCESS](state: IState, payload) {
        state.fileList.loading = false;
        const { req, res } = payload;
        const exitIndex = state.fileList.infos.findIndex((item: any) => item.type === req.type);
        if (exitIndex > -1) {
            (state.fileList.infos as any).split(exitIndex, 1);
        }
        state.fileList.infos.push({
            type: req.type,
            data: res && res.Data || []
        });
    },
    [TYPES.GET_FOLDER_FILES_NAME.FAILED](state: IState) {
        state.fileList.loading = false;
    }
};
